import React from 'react';
import { IoLocationSharp } from 'react-icons/io5';
import { IoDocumentsOutline } from 'react-icons/io5';
import { BsBox } from 'react-icons/bs';
import { BsCreditCardFill } from 'react-icons/bs';
import { RiCalendarEventFill } from 'react-icons/ri';
import { GiMedicalPack } from 'react-icons/gi';
import { FaTruckFast } from 'react-icons/fa6';
import { MdCancel } from 'react-icons/md';
import { BiSolidInfoCircle } from 'react-icons/bi';
import { IoMdWarning } from 'react-icons/io';
import { RxTriangleLeft } from 'react-icons/rx';

import visaimg from '../../../../../assets/images/booking/visa.png';
import masterimg from '../../../../../assets/images/booking/master.png';
import discoverimg from '../../../../../assets/images/booking/discover.png';
import ameximg from '../../../../../assets/images/booking/amex.png';
import FormWrapper from '../../FormWrapper/FormWrapper';
import { formatCurrency } from '../../../../../utils/formatCurrency';

const CreateShipment = ({
  transitCost,
  currencyUtils,
  fetchedFormData,
  ...bookingInfo
}) => {
  const { convert, getCurrencySymbol, selectedCurrency } = currencyUtils;
  const { shipmentArrivalDate } = bookingInfo;

  const { city, country } = fetchedFormData;

  const getCountry = (param) => {
    console.log(param, country);
    const filteredCountry = country?.find(
      (item) => item.id === parseInt(param)
    );
    return filteredCountry?.name;
  };
  const getCity = (param) => {
    const filteredCountry = city?.find((item) => item.id === parseInt(param));
    return filteredCountry?.name;
  };

  // Calculate aggregated totals from all items
  const aggregatedTotals = transitCost && transitCost.length > 0 ? {
    disCountedPercentageAmount: transitCost.reduce((sum, item) => sum + (parseFloat(item.disCountedPercentageAmount) || 0), 0),
    afterDiscountCost: transitCost.reduce((sum, item) => sum + (parseFloat(item.afterDiscountCost) || 0), 0),
    vatPercentageAmount: transitCost.reduce((sum, item) => sum + (parseFloat(item.vatPercentageAmount ?? item.vatAmount) || 0), 0),
    totalCostWithoutVAT: transitCost.reduce((sum, item) => sum + (parseFloat(item.totalCostWithoutVAT) || 0), 0),
    totalCostWithVAT: transitCost.reduce((sum, item) => {
      const net = parseFloat(item.totalCostWithoutVAT) || 0;
      const vat = parseFloat(item.vatPercentageAmount ?? item.vatAmount) || 0;
      const withVat = parseFloat(item.totalCostWithVAT);
      return sum + (Number.isFinite(withVat) && withVat > 0 ? withVat : net + vat);
    }, 0),
  } : {
    disCountedPercentageAmount: 0,
    afterDiscountCost: 0,
    vatPercentageAmount: 0,
    totalCostWithVAT: 0,
    totalCostWithoutVAT: 0,
  };

  const tableData = [
    {
      header: 'Discount Amount',
      property: 'disCountedPercentageAmount',
    },
    {
      header: 'After Discount Cost',
      property: 'afterDiscountCost',
    },
    {
      header: 'Total Cost Without VAT',
      property: 'totalCostWithoutVAT',
    },
    {
      header: 'VAT',
      property: 'vatPercentageAmount',
    },
    {
      header: 'Total Cost',
      property: 'totalCostWithVAT',
    },
  ].map((item) => ({
    ...item,
    displayValue:
      transitCost && transitCost.length > 0
        ? formatCurrency(convert(aggregatedTotals[item.property]), selectedCurrency, {
            currencyType: selectedCurrency,
          })
        : 'N/A',
  }));

  return (
    <FormWrapper title='Cost Review'>
      <div className=''>
        <div className='  gap-y-[2px] glass-morphism py-4 border border-black pl-2   text-black'>
          <div className=' flex 2xl:gap-0 gap-5  justify-center items-center  flex-col 2xl:flex-row py-2'>
            <div className='2xl:w-1/2 w-full flex flex-col justify-between items-start'>
              <div className=' lg:w-1/5 flex items-start gap-x-2 '>
                <IoLocationSharp className='text-gray-400 text-2xl ' />{' '}
                <span className='font-bold text-xl'>From</span>
              </div>
              <div className='w-full font-medium text-base pl-9 break-words whitespace-normal overflow-hidden'>
                <h1>{bookingInfo?.senderName}</h1>
                <h1>{bookingInfo?.senderAddress}</h1>
                <h1>{getCity(bookingInfo?.senderCity)}</h1>
                <h1>{getCountry(bookingInfo?.senderCountry)}</h1>
                <h1>{bookingInfo?.senderPostCode}</h1>

                {/* <h1>
                  <span className="font-bold text-lg">E-mail:</span>{" "}
                  {bookingInfo?.senderEmail}
                </h1> */}
                <h1 className='break-words'>
                  <span className='font-bold text-lg'>E-mail:</span>{' '}
                  {bookingInfo?.senderEmail}
                </h1>

                <h1>
                  <span className='font-bold text-lg'>Phone:</span>{' '}
                  {bookingInfo?.senderMobileNumber}
                </h1>
              </div>
            </div>
            <div className='2xl:w-1/2 w-full flex flex-col justify-between items-start'>
              <div className=' lg:w-1/5 flex items-start gap-x-2 '>
                <IoLocationSharp className='text-gray-400 text-2xl ' />{' '}
                <span className='font-bold text-xl'>To</span>
              </div>
              <div className='w-full font-medium text-base pl-9 break-words whitespace-normal overflow-hidden'>
                <h1>{bookingInfo?.receiverName}</h1>
                <h1>{bookingInfo?.receiverAddress}</h1>
                <h1>{getCity(bookingInfo?.receiverCity)}</h1>
                <h1>{getCountry(bookingInfo?.receiverCountry)}</h1>
                <h1>{bookingInfo?.receiverPostCode}</h1>

                {/* <h1>
                  <span className="font-bold text-lg">E-mail:</span>{" "}
                  {bookingInfo?.receiverEmail}
                </h1> */}
                <h1 className='break-words'>
                  <span className='font-bold text-lg'>E-mail:</span>{' '}
                  {bookingInfo?.receiverEmail}
                </h1>

                <h1>
                  <span className='font-bold text-lg'>Phone:</span>{' '}
                  {bookingInfo?.receiverMobileNumber}
                </h1>
              </div>
            </div>
          </div>

          <div className='flex justify-start items-center mt-3 py-2'>
            <div className='lg:w-1/2 flex items-start justify-start gap-x-4'>
              <BsBox className='text-gray-400 text-2xl' />
              <div className='text-base font-medium '>
                {bookingInfo?.producDetails && bookingInfo.producDetails.length > 0 ? (
                  <div className='flex flex-col gap-1'>
                    {bookingInfo.producDetails.map((item, index) => {
                      const itemLength = item.itemLength !== undefined && item.itemLength !== "" ? item.itemLength : (index === 0 ? bookingInfo?.productLength : "");
                      const itemWidth = item.itemWidth !== undefined && item.itemWidth !== "" ? item.itemWidth : (index === 0 ? bookingInfo?.productWidth : "");
                      const itemHeight = item.itemHeight !== undefined && item.itemHeight !== "" ? item.itemHeight : (index === 0 ? bookingInfo?.productHeight : "");
                      const itemWeight = item.itemWeight !== undefined && item.itemWeight !== "" ? item.itemWeight : (index === 0 ? bookingInfo?.productWeight : "");
                      const preset = item.preset || bookingInfo?.preset || "";
                      
                      return (
                        <div key={index}>
                          {bookingInfo.producDetails.length > 1 && <span className='font-semibold'>Box {index + 1}: </span>}
                          {preset ? `${preset} - ` : ""}
                          {itemLength && itemWidth && itemHeight 
                            ? `(${itemLength} x ${itemWidth} x ${itemHeight} in)` 
                            : ""}
                          {itemWeight ? ` - ${itemWeight}kg` : ""}
                          {item.deliveryPlanName ? ` - ${item.deliveryPlanName}` : ""}
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  `${bookingInfo?.preset || ""} - (${bookingInfo?.productLength || ""} x ${bookingInfo?.productWidth || ""} x ${bookingInfo?.productHeight || ""} in) - ${bookingInfo?.productWeight || ""}kg `
                )}
              </div>
            </div>
            <div className='lg:w-1/2 flex justify-between items-center'>
              <div className=' flex   w-3/5 items-start justify-start gap-x-1'>
                <div className=' w-1/5'></div>
                <div className='  w-full text-[10px] font-medium '></div>
              </div>
              <div className=' pr-2'>
                {/* <button type='button' className=' shadow-md font-medium px-2 py-1 text-xs bg-gray-500 text-gray-50 rounded-sm'>Edit</button> */}
              </div>
            </div>
          </div>

          <div className='flex justify-center items-center py-2'>
            <div className='lg:w-1/2 w-full  flex items-start justify-start gap-x-4'>
              <RiCalendarEventFill className='text-gray-400 text-2xl' />
              <div className='text-base font-medium '>
                <span className='font-bold text-base'>Shipment Date</span>{' '}
                {`${shipmentArrivalDate?.month} ${shipmentArrivalDate?.date},${shipmentArrivalDate?.day}`}{' '}
                <br />
                {/* <span className='font-bold text-xs'>Shipment Cost</span> 124.91 USD */}
              </div>
            </div>
            <div className='lg:w-1/2 flex justify-between items-center'>
              <div className=' flex   w-3/5 items-start justify-start gap-x-1'>
                <div className=' w-1/5'></div>
                {/* <div className="  w-full text-[10px] font-medium ">
                                <span className='font-bold text-xs'>Delivery Date</span> Mon, 20 May, 2024 <br />
                                <span className='font-bold text-xs'>Delivered By</span> End of Day
                            </div> */}
              </div>
              <div className=' pr-2'>
                {/* <button type='button' className=' shadow-md font-medium px-2 py-1 text-xs bg-gray-500 text-gray-50 rounded-sm'>Edit</button> */}
              </div>
            </div>
          </div>

          {
            //     <div className="flex justify-center items-center py-2 pl-2">
            //     <div className="w-1/2 flex items-start justify-start gap-x-4">
            //         <GiMedicalPack className='text-gray-400 text-lg' />
            //         <div className="text-[10px] font-medium ">
            //             <span className='font-bold text-xs'>Optional Services</span> <br />
            //             GoGreen Plus <br /> Direct Signature
            //         </div>
            //     </div>
            //     <div className='w-1/2 flex justify-between items-center'>
            //         <div className=" flex   w-3/5 items-start justify-start gap-x-1">
            //             <div className=" w-1/5"></div>
            //             <div className="  w-full text-[10px] font-medium ">
            //             </div>
            //         </div>
            //         <div className=" pr-2">
            //             {/* <button type='button' className=' shadow-md font-medium px-2 py-1 text-xs bg-gray-500 text-gray-50 rounded-sm'>Edit</button> */}
            //         </div>
            //     </div>
            // </div>
          }

          {
            //      <div className="flex justify-center items-center py-2 pl-2">
            //      <div className="w-1/2 flex items-start justify-start gap-x-4">
            //          <FaTruckFast className='text-gray-400 text-lg' />
            //          <div className="text-[10px] font-medium ">
            //              <span className='font-bold text-xs'>No Pickup Requested</span>
            //          </div>
            //      </div>
            //      <div className='w-1/2 flex justify-between items-center'>
            //          <div className=" flex   w-3/5 items-start justify-start gap-x-1">
            //              <div className=" w-1/5"></div>
            //              <div className="  w-full text-[10px] font-medium text-gray-400">
            //              </div>
            //          </div>
            //          <div className=" pr-2">
            //              {/* <button type='button' className=' shadow-md font-medium px-2 py-1 text-xs bg-gray-500 text-gray-50 rounded-sm'>Edit</button> */}
            //          </div>
            //      </div>
            //  </div>
          }
        </div>

        <div className='  glass-morphism p-4 mt-4'>
          <h1 className='font-bold py-3 text-xl'>Shipment Cost Summary</h1>
          <div className='w-full mt-4 flex justify-end items-start'>
            <div className=' w-full min-h-32 '>
              {/* <table className='w-max  text-sm'>
                                <tr className=' grid-cols-4  w-full '>
                                    <th className='text-start'>Currency</th>
                                     <th className='text-start'>Cargo Cost</th>
                                    <th className='text-center'>Dimension Cost</th>
                                    <th className='text-center'>Weight Cost</th>
                                    <th className='text-center'>ExtraPackaging Cost</th>
                                    <th className='text-center'>ItemType Cost</th>
                                    <th className='text-center'>PickUp Cost</th>
                                    <th className='text-center'>Route Cost</th>
                                    <th className='text-center'>Shipping Service Cost</th>
                                    <th className='text-center'>Discount Amount</th>
                                    <th className='text-center'>r</th>
                                    <th className='text-center text-red-500'>VAT</th>
                                    <th className='text-center'>TotalCost With VAT</th>
                                    <th className='text-end'>TotalCost Without VAT</th>
                                   
                                  
                                    
                                    <th className='text-end font-medium  py-1'>Discounted <br /> Rate</th>
                                </tr>
                                <tr className='hidden'>
                                    
                                    <td className='text-start  py-1'>{transitCost[0]?.cargoCost}</td>
                                    <td className='text-center py-1'>{transitCost[0]?.dimensionCost}</td>
                                    <td className='text-center py-1'>{transitCost[0]?.weightCost}</td>
                                    <td className='text-center py-1'>{transitCost[0]?.extraPackagingCost}</td>
                                    <td className='text-center py-1'>{transitCost[0]?.itemTypeCost}</td>
                                    <td className='text-center py-1'>{transitCost[0]?.pickUpCost}</td>
                                    <td className='text-center py-1'>{transitCost[0]?.routeCost}</td>
                                    <td className='text-center py-1'>{transitCost[0]?.shippingServiceCost}</td>
                                    <td className='text-center py-1'>{transitCost[0]?.disCountedPercentageAmount}</td>
                                    <td className='text-center py-1'>{transitCost[0]?.afterDiscountCost}</td>
                                    <td className='text-center py-1 text-red-500'>{transitCost[0]?.vatAmount}</td>
                                    <td className='text-center py-1'>{transitCost[0]?.totalCostWithVAT}</td>
                                    <td className='text-end py-1'>{transitCost[0]?.totalCostWithoutVAT}</td>
                                </tr>
                                <tr>
                                    <td className=''></td>
                                    <td className=''></td>
                                    <td className=''></td>
                                    <td className=''></td>
                                    <td className=''></td>
                                    <td className=''></td>
                                    <td className=''></td>
                                    <td className=''></td>
                                    <td className=''></td>
                                    <td className=''></td>
                                    <td className=''></td>
                                    <td className=''></td>
                                    <td className=''></td>
                                  
                                </tr>
                            </table> */}
              <div className={`py-2 bg-[#f7d5c3c9] `}>
                <div className='px-3 flex justify-between items-center'>
                  <span className='font-bold text-lg'>Cost Name</span>
                  <span className='font-bold text-lg'>Amount</span>
                </div>
              </div>

              {tableData?.map((item, idx) => {
                return (
                  <div
                    className={`py-2 ${
                      idx % 2 === 0 ? 'bg-[#fff6f1c9]' : 'bg-[#f7ded1]'
                    }`}
                    key={idx}
                  >
                    {/* <div className="px-3 flex justify-between items-center">
                      {" "}
                      <span className="">{item.header}</span>{" "}
                      <span className="font-bold">
                        {transitCost[0] && transitCost[0][item.property]} £ 
                        {transitCost[0] && transitCost[0][item.property]} {selectedCurrency}
                      </span>
                    </div> */}

                    <div
                      className={`py-2 ${
                        idx % 2 === 0 ? 'bg-[#fff6f1c9]' : 'bg-[#f7ded1]'
                      }`}
                    >
                      <div className='px-3 flex justify-between items-center'>
                        <span className=''>{item.header}</span>
                        <span className='font-bold'>{item.displayValue}</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </FormWrapper>
  );
};

export default CreateShipment;
